import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import api from '../commonJs/http.js'
import base64 from '../commonJs/base64'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import menu from '../router/menu.js'
import authorization from '../router/authorization.js'
import Main from '../views/Main.vue'
import ClientMain from '../views/Client/Main.vue'

Vue.use(VueRouter)
//element UI导航栏中的vue-router在3。0以上版本的重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

NProgress.configure({
  showSpinner: false
}) // 禁用加载环

let routes = [{
    path: '/',
    name: 'Main',
    component: Main,
    children: [
        {
            path: '/Layout',
            name: "Layout",
            component: () => import('../views/IframeLayout/Layout'),
            meta: {
                desc: '用来嵌套第三方页面'
            }
        },
        {
            path: '/Admin/Index',
            name: "AdminIndex",
            component: () => import('../views/Admin/HomeCloud/HomeCloud.vue'),
            meta: {
                desc: '首页'
            }
        },
        {
            path: '/Admin/CompanyProfile',
            name: "CompanyProfile",
            component: () => import('../views/Admin/AboutSailHero/CompanyProfile/CompanyProfile.vue'),
            meta: {
                desc: '公司介绍管理'
            }
        },
        {
            path: '/Admin/ChairmanSpeech',
            name: "ChairmanSpeech",
            component: () => import('../views/Admin/AboutSailHero/ChairmanSpeech/ChairmanSpeech.vue'),
            meta: {
                desc: '董事长致辞管理'
            }
        },
        {
            path: '/Admin/GloriousHistory',
            name: "GloriousHistory",
            component: () => import('../views/Admin/AboutSailHero/GloriousHistory/GloriousHistory.vue'),
            meta: {
                desc: '光辉历程管理'
            }
        },
        {
            path: '/Admin/QualificationsHonors',
            name: "QualificationsHonors",
            component: () => import('../views/Admin/AboutSailHero/QualificationsHonors/QualificationsHonors.vue'),
            meta: {
                desc: '资质荣誉管理'
            }
        },
        {
            path: '/Admin/OverviewSilhouette',
            name: "OverviewSilhouette",
            component: () => import('../views/Admin/AboutSailHero/OverviewSilhouette/OverviewSilhouette.vue'),
            meta: {
                desc: '概貌剪影管理'
            }
        },
        {
            path: '/Admin/CarouselPicturesOfPartyBuilding',
            name: "CarouselPicturesOfPartyBuilding",
            component: () => import('../views/Admin/AboutSailHero/PartyAffairsConstruction/CarouselPicturesOfPartyBuilding.vue'),
            meta: {
                desc: '党建轮播图片'
            }
        },
        {
            path: '/Admin/IntroductionToTheGeneralPartyBranch',
            name: "IntroductionToTheGeneralPartyBranch",
            component: () => import('../views/Admin/AboutSailHero/PartyAffairsConstruction/IntroductionToTheGeneralPartyBranch.vue'),
            meta: {
                desc: '党总支简介'
            }
        },
        {
            path: '/Admin/PartyBuildingDynamics',
            name: "PartyBuildingDynamics",
            component: () => import('../views/Admin/AboutSailHero/PartyAffairsConstruction/PartyBuildingDynamics.vue'),
            meta: {
                desc: '党总支简介'
            }
        },
        {
            path: '/Admin/SocialResponsibility',
            name: "SocialResponsibility",
            component: () => import('../views/Admin/AboutSailHero/SocialResponsibility/SocialResponsibility.vue'),
            meta: {
                desc: '社会责任管理'
            }
        },
        {
            path: '/Admin/LeadershipCare',
            name: "LeadershipCare",
            component: () => import('../views/Admin/AboutSailHero/LeadershipCare/LeadershipCare.vue'),
            meta: {
                desc: '领导关怀管理'
            }
        },
        {
            path: '/Admin/EmployeeWorld',
            name: "EmployeeWorld",
            component: () => import('../views/Admin/AboutSailHero/CorporateCulture/EmployeeWorld.vue'),
            meta: {
                desc: '员工天地管理'
            }
        },
        {
            path: '/Admin/NewsTrends',
            name: "NewsTrends",
            component: () => import('../views/Admin/NewsCenter/NewsTrends.vue'),
            meta: {
                desc: '新闻动态'
            }
        },
        {
            path: '/Admin/InvestorRelations',
            name: "InvestorRelations",
            component: () => import('../views/Admin/NewsCenter/InvestorRelations.vue'),
            meta: {
                desc: '投资者关系'
            }
        },
        {
            path: '/Admin/PartyWork',
            name: "PartyWork",
            component: () => import('../views/Admin/NewsCenter/PartyWork.vue'),
            meta: {
                desc: '党务建设'
            }
        },
        {
            path: '/Admin/CulturalPublications',
            name: "CulturalPublications",
            component: () => import('../views/Admin/AboutSailHero/CorporateCulture/CulturalPublications.vue'),
            meta: {
                desc: '文化刊物管理'
            }
        },
        {
            path: '/Admin/AfterSalesOffice',
            name: "AfterSalesOffice",
            component: () => import('../views/Admin/ContactUs/AfterSalesOffice.vue'),
            meta: {
                desc: '售后办事处管理'
            }
        },
        {
            path: '/Admin/Business/ProductType',
            name: "ProductType",
            component: () => import('../views/Admin/Business/ProductType.vue'),
            meta: {
                desc: '产品分类'
            }
        },
        {
            path: '/Admin/Business/Product',
            name: "ProductType",
            component: () => import('../views/Admin/Business/Product.vue'),
            meta: {
                desc: '产品中心'
            }
        },
        {
            path: '/Admin/Business/SolutionType',
            name: "SolutionType",
            component: () => import('../views/Admin/Business/SolutionType.vue'),
            meta: {
                desc: '方案分类'
            }
        },
        {
            path: '/Admin/Business/Solution',
            name: "Solution",
            component: () => import('../views/Admin/Business/Solution.vue'),
            meta: {
                desc: '解决方案'
            }
        },
        {
            path: '/Admin/MemberMain',
            name: "MemeberMain",
            component: () => import('../views/Admin/MemberMain/MemeberMain.vue'),
            meta: {
                desc: '分子公司'
            }
        },
        {
            path: '/Admin/WebsiteMessage',
            name: "WebsiteMessage",
            component: () => import('../views/Admin/ContactUs/WebsiteMessage.vue'),
            meta: {
                desc: '网站留言'
            }
        },
        {
            path: '/Admin/OpenPositions',
            name: "OpenPositions",
            component: () => import('../views/Admin/HumanResources/OpenPositions.vue'),
            meta: {
                desc: '招聘职位管理'
            }
        },
        {
            path: '/Admin/HomeCloud',
            name: "HomeCloud",
            component: () => import('../views/Admin/HomeCloud/HomeCloud.vue'),
            meta: {
                desc: '六朵云'
            }
        }
    ]
  },
  {
        path:'/',
        name:'ClientMain',
        component:ClientMain,
        children:[
            {
                path: '/Layout',
                name: "Layout",
                component: () => import('../views/IframeLayout/Layout'),
                meta: {
                    desc: '用来嵌套第三方页面'
                }
            },
            {
                path: '/Client/Index',
                name: "ClientIndex",
                component: () => import('../views/Client/Index.vue'),
                meta: {
                    menuid:'1',
                    desc: '首页',
                }
            },
            {
                path: '/Client/AboutSailHero/index',
                name: "AboutSailHeroIndex",
                component: () => import('../views/Client/AboutSailHero/index.vue'),
                meta: {
                    menuid:'2',
                    desc: '关于先河',
                }
            },
            {
                path: '/Client/AboutSailHero/Introduction',
                name: "AboutSailHeroIntroduction",
                component: () => import('../views/Client/AboutSailHero/MobileIntroduction.vue'),
                meta: {
                    menuid:'2',
                    desc: '先河介绍',
                }
            },
            {
                path: '/Client/AboutSailHero/PartyBuildingWork',
                name: "MobilePartyBuildingWork",
                component: () => import('../views/Client/AboutSailHero/MobilePartyBuildingWork.vue'),
                meta: {
                    menuid:'2',
                    desc: '党建工作',
                }
            },
            {
                path: '/Client/AboutSailHero/SocialResponsibility',
                name: "MobileSocialResponsibility",
                component: () => import('../views/Client/AboutSailHero/MobileSocialResponsibility.vue'),
                meta: {
                    menuid:'2',
                    desc: '社会责任',
                }
            },
            {
                path: '/Client/AboutSailHero/LeadershipCare',
                name: "MobileLeadershipCare",
                component: () => import('../views/Client/AboutSailHero/MobileLeadershipCare.vue'),
                meta: {
                    menuid:'2',
                    desc: '领导关怀',
                }
            },
            {
                path: '/Client/AboutSailHero/CorporateCulture',
                name: "MobileCorporateCulture",
                component: () => import('../views/Client/AboutSailHero/MobileCorporateCulture.vue'),
                meta: {
                    menuid:'2',
                    desc: '企业文化',
                }
            },
            {
                path: '/Client/AboutSailHero/HumanResources',
                name: "MobileHumanResources",
                component: () => import('../views/Client/AboutSailHero/MobileHumanResources.vue'),
                meta: {
                    menuid:'2',
                    desc: '人力资源',
                }
            },
            {
                path: '/Client/CorporateCultureDetails',
                name: "CorporateCultureDetails",
                component: () => import('../views/Client/AboutSailHero/components/NewsDetails.vue'),
                meta: {
                    menuid:'5',
                    desc: '新闻详情',
                }
            },
            {
                path: '/Client/NewsTrends',
                name: "ClientNewsTrends",
                component: () => import('../views/Client/NewsTrends/NewsTrends.vue'),
                meta: {
                    menuid:'5',
                    desc: '新闻动态',
                }
            },
            {
                path: '/Client/NewsDetails',
                name: "ClientNewsDetails",
                component: () => import('../views/Client/NewsTrends/NewsDetails.vue'),
                meta: {
                    menuid:'5',
                    desc: '新闻详情',
                }
            },
            {
                path: '/Client/PartyWork',
                name: "ClientPartyWork",
                component: () => import('../views/Client/PartyWork/PartyWork.vue'),
                meta: {
                    menuid: '6',
                    desc: '党务建设',
                }
            },
            {
                path: '/Client/PartyWorkMore',
                name: "ClientPartyWorkMore",
                component: () => import('../views/Client/PartyWork/PartyWorkMore.vue'),
                meta: {
                    menuid: '6',
                    desc: '党务建设列表',
                }
            },
            {
                path: '/Client/PartyWorkDetails',
                name: "ClientPartyWorkDetails",
                component: () => import('../views/Client/PartyWork/PartyWorkDetails.vue'),
                meta: {
                    menuid: '6',
                    desc: '党务建设详情',
                }
            },
            {
                path: '/Client/InvestorRelations',
                name: "ClientInvestorRelations",
                component: () => import('../views/Client/InvestorRelations/InvestorRelations.vue'),
                meta: {
                    menuid:'7',
                    desc: '投资者关系',
                }
            },
            {
                path: '/Client/InvestorRelationsDetails',
                name: "ClientInvestorRelationsDetails",
                component: () => import('../views/Client/InvestorRelations/InvestorRelationsDetails.vue'),
                meta: {
                    menuid:'7',
                    desc: '投资者关系详情',
                }
            },
            {
                path: '/Client/Business/Product',
                name: "Product",
                component: () => import('../views/Client/Business/Product.vue'),
                meta: {
                    menuid: '3',
                    desc: '产品中心',
                }
            },
            {
                path: '/Client/Business/Solution',
                name: "Solution",
                component: () => import('../views/Client/Business/Solution.vue'),
                meta: {
                    menuid: '4',
                    desc: '解决方案',
                }
            },
            {
                path: '/Client/Member',
                name: "Member",
                component: () => import('../views/Client/MemberMain/MemberMain.vue'),
                meta: {
                    menuid: '9',
                    desc: '分子公司',
                }
            },
            {
                path: '/Client/MemberInfo',
                name: "MemberInfo",
                component: () => import('../views/Client/MemberMain/MemberInfo.vue'),
                meta: {
                    menuid: '9',
                    desc: '分子公司详情',
                }
            },
            {
                path: '/Client/HumanResources/index',
                name: "HumanResourcesIndex",
                component: () => import('../views/Client/HumanResources/index.vue'),
                meta: {
                    menuid: '8',
                    desc: '人力资源',
                }
            },
            {
                path: '/Client/ContactUs/index',
                name: "ContactUsIndex",
                component: () => import('../views/Client/ContactUs/index.vue'),
                meta: {
                    menuid: '10',
                    desc: '联系我们',
                }
            },
            {
                path: '/Client/CloudInfo',
                name: "CloudInfo",
                component: () => import('../views/Client/CloudInfo.vue'),
                meta: {
                    desc: '六朵云详情'
                }
            },
            {
                path: '/Client/Search',
                name: "ClientSearch",
                component: () => import('../views/Client/Search/Search.vue'),
                meta: {
                    desc: '搜索结果'
                }
            }
        ]
  },
  {
    path: '/AttachmentImgList',
    name: "AttachmentImgList",
    component: () => import('../components/AttachmentImgList.vue'),
    meta: {
        desc: ''
    }
  },
  {
    path: '/NoAuth',
    name: 'NoAuth',
    component: () => import('../views/ErrorPage/401.vue')
  },
  {
    path: '/Error',
    name: 'Error',
    component: () => import('../views/ErrorPage/500.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/ErrorPage/404.vue')

  }
]

const router = new VueRouter({
  // mode:'history',
  routes: []
})


//async,等待函数(异步)
router.beforeEach(async (to, from, next) => {
    if(to.fullPath.substring(0,7)==='/Admin/')
    {
       NProgress.start();
         //登录判断
       if (!authorization.Authorization(to, next)) {
           return
         }
         //加载菜单
         menu.LoadMenu(router, routes, 0, to, next, NProgress,true);

         NProgress.done();
    }else{
         NProgress.start();
         menu.LoadMenu(router, routes, 0, to, next, NProgress,false);
         NProgress.done();
    }
});


export default router
